var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var APIVERSION = "0.0.4";
var debug = require("debug");
import h from "../helper/helper";
import { connect } from "socket.io-client";
var config = require('../config.js');
import * as Bluebird from "bluebird";
import Observer from "../asset/observer";
import BlobUploader from "./blobUploader.service";
import { goToBusiness, goToSalesPage } from "./location.manager";
var socketDebug = debug("whispeer:socket");
var socketError = debug("whispeer:socket:error");
export var DisconnectError = h.createErrorType("disconnectedError");
export var ServerError = h.createErrorType("serverError");
var SOCKET_TIMEOUT = 60000;
var log = {
    timer: function (name) {
        var message = new Date().toLocaleTimeString() + ":" + name + "(" + Math.random() + ")";
        if (debug.enabled("whispeer:socket")) {
            console.time(message);
        }
        return message;
    },
    timerEnd: function (message) {
        if (debug.enabled("whispeer:socket")) {
            console.timeEnd(message);
        }
    }
};
var SocketService = /** @class */ (function (_super) {
    __extends(SocketService, _super);
    function SocketService() {
        var _this = _super.call(this) || this;
        _this._interceptors = [];
        _this._domain = (config.https ? "https://" : "http://") + config.ws + ":" + config.wsPort;
        _this._autoReconnect = config.socket.autoReconnect;
        _this._autoConnect = config.socket.autoConnect;
        _this._lastRequestTime = 0;
        _this._loading = 0;
        _this.uploadObserver = new Observer();
        _this._uploadingCounter = 0;
        _this.errors = {
            Disconnect: DisconnectError,
            Server: ServerError
        };
        _this.uploadBlob = function (blob, blobid, progress, cb) {
            if (_this._uploadingCounter > 3) {
                _this.uploadObserver.listenOnce(function () {
                    _this.uploadBlob(blob, blobid, progress, cb);
                }, "uploadFinished");
                return;
            }
            _this._uploadingCounter++;
            var uploader = new BlobUploader(_this, blob, blobid);
            uploader.listen(function (doneBytes) {
                progress.progress(doneBytes);
            }, "progress");
            var uploadPromise = uploader.upload().then(function () {
                _this._uploadingCounter--;
                _this.uploadObserver.notify(blobid, "uploadFinished");
                _this.uploadObserver.notify(blobid, "uploadFinished:" + blobid);
            });
            return uploadPromise.nodeify(cb);
        };
        if (_this._autoConnect) {
            _this._connect();
        }
        if (_this._autoConnect && _this._autoReconnect) {
            window.setInterval(function () {
                try {
                    if (!_this._socket.connected) {
                        _this._socket.connect();
                    }
                }
                catch (e) {
                    socketError(e);
                }
            }, 10000);
        }
        return _this;
    }
    SocketService.prototype._connect = function () {
        var _this = this;
        this._socket = connect(this._domain, config.socket.options);
        this._socket.on("disconnect", function () {
            socketDebug("socket disconnected");
            _this._loading = 0;
            _this._uploadingCounter = 0;
        });
        this._socket.on("connect", function () {
            socketDebug("socket connected");
            _this.emit("whispeerPing", {});
            _this._socket.io.engine.on("heartbeat", function () {
                _this.notify(null, "heartbeat");
            });
        });
    };
    SocketService.prototype._emit = function (channel, request) {
        var _this = this;
        return new Bluebird(function (resolve, reject) {
            var onDisconnect = function () {
                reject(new DisconnectError("Disconnected while sending"));
            };
            _this._socket.once("disconnect", onDisconnect);
            _this._socket.emit(channel, request, function (response) {
                _this._socket.off("disconnect", onDisconnect);
                resolve(response);
            });
        });
    };
    SocketService.prototype.getLoadingCount = function () {
        return this._loading;
    };
    ;
    SocketService.prototype.lastRequestTime = function () {
        return this._lastRequestTime;
    };
    ;
    SocketService.prototype.send = function (data) {
        this._socket.send(data);
    };
    SocketService.prototype.addInterceptor = function (interceptor) {
        this._interceptors.push(interceptor);
    };
    SocketService.prototype.isConnected = function () {
        return this._socket.connected;
    };
    SocketService.prototype.emit = function (channel, request, cb) {
        var _this = this;
        if (!this.isConnected()) {
            throw new DisconnectError("no connection");
        }
        var timer = log.timer("request on " + channel);
        request.version = APIVERSION;
        request.clientInfo = CLIENT_INFO;
        socketDebug("Request on " + channel, request);
        this._interceptors.forEach(function (interceptor) {
            if (interceptor.transformRequest) {
                request = interceptor.transformRequest(request);
            }
        });
        this._loading++;
        this.notify(null, "request");
        return this._emit(channel, request).timeout(SOCKET_TIMEOUT).then(function (response) {
            socketDebug("Answer on " + channel, response);
            log.timerEnd(timer);
            if (response.alert) {
                alert(response.alert);
            }
            _this._lastRequestTime = response.serverTime;
            _this._interceptors.forEach(function (interceptor) {
                if (interceptor.transformResponse) {
                    response = interceptor.transformResponse(response, request);
                }
            });
            if (response.error) {
                socketError(response);
                throw new ServerError("server returned an error!", { response: response });
            }
            if (!WHISPEER_BUSINESS) {
                if (response.isBusiness) {
                    goToBusiness();
                }
            }
            if (WHISPEER_BUSINESS) {
                if (response.loggedin && !response.isBusiness && !request.ignoreBusiness) {
                    goToSalesPage();
                }
            }
            return response;
        }).finally(function () {
            _this._loading--;
            _this.notify(null, "response");
        }).nodeify(cb);
    };
    SocketService.prototype.awaitNoRequests = function () {
        var _this = this;
        if (this._loading === 0) {
            return Bluebird.resolve();
        }
        return new Bluebird(function (resolve) {
            _this.listen(function () {
                if (_this._loading === 0) {
                    resolve();
                }
            }, "response");
        });
    };
    SocketService.prototype.awaitConnection = function () {
        var _this = this;
        return new Bluebird(function (resolve) {
            if (_this.isConnected()) {
                resolve();
            }
            else {
                _this.once("connect", resolve);
            }
        });
    };
    SocketService.prototype.on = function (eventName, callback) {
        return this._socket.on(eventName, callback);
    };
    SocketService.prototype.once = function (eventName, callback) {
        return this._socket.once(eventName, callback);
    };
    /** definitly emits the request. might emit it multiple times! **/
    SocketService.prototype.definitlyEmit = function (channel, request) {
        var _this = this;
        var SOCKET_TIMEOUT = 10000;
        return this.awaitConnection().then(function () {
            return _this.emit(channel, request).timeout(SOCKET_TIMEOUT);
        }).catch(function (e) {
            console.error(e);
            return Bluebird.delay(500).then(function () {
                return _this.definitlyEmit(channel, request);
            });
        });
    };
    SocketService.prototype.channel = function (channel, callback) {
        this._socket.on(channel, function (data) {
            socketDebug("received data on " + channel);
            socketDebug(data);
            callback(null, data);
        });
    };
    SocketService.errors = {
        Disconnect: DisconnectError,
        Server: ServerError
    };
    return SocketService;
}(Observer));
export default new SocketService();



//////////////////
// WEBPACK FOOTER
// ./js/services/socket.service.ts
// module id = null
// module chunks = 